// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceFilterType
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DataSourceFilterType = /*#__PURE__*/function (DataSourceFilterType) {
  DataSourceFilterType[DataSourceFilterType["STRING_BEGINS_WITH"] = 0] = "STRING_BEGINS_WITH";
  DataSourceFilterType[DataSourceFilterType["STRING_ENDS_WITH"] = 1] = "STRING_ENDS_WITH";
  DataSourceFilterType[DataSourceFilterType["STRING_CONTAINS"] = 2] = "STRING_CONTAINS";
  DataSourceFilterType[DataSourceFilterType["IS"] = 3] = "IS";
  DataSourceFilterType[DataSourceFilterType["IS_NOT"] = 4] = "IS_NOT";
  DataSourceFilterType[DataSourceFilterType["IS_NULL"] = 5] = "IS_NULL";
  DataSourceFilterType[DataSourceFilterType["IS_NOT_NULL"] = 6] = "IS_NOT_NULL";
  DataSourceFilterType[DataSourceFilterType["GREATER_THAN"] = 7] = "GREATER_THAN";
  DataSourceFilterType[DataSourceFilterType["GREATER_THAN_OR_EQUAL"] = 8] = "GREATER_THAN_OR_EQUAL";
  DataSourceFilterType[DataSourceFilterType["LESS_THAN"] = 9] = "LESS_THAN";
  DataSourceFilterType[DataSourceFilterType["LESS_THAN_OR_EQUAL"] = 10] = "LESS_THAN_OR_EQUAL";
  DataSourceFilterType[DataSourceFilterType["BETWEEN"] = 11] = "BETWEEN";
  DataSourceFilterType[DataSourceFilterType["IN"] = 12] = "IN";
  DataSourceFilterType[DataSourceFilterType["NOT_IN"] = 13] = "NOT_IN";
  DataSourceFilterType[DataSourceFilterType["HAS_WHOLE_WORDS"] = 14] = "HAS_WHOLE_WORDS";
  DataSourceFilterType[DataSourceFilterType["OBJECT_NAME_IS"] = 15] = "OBJECT_NAME_IS";
  DataSourceFilterType[DataSourceFilterType["OBJECT_NAME_IS_NOT"] = 16] = "OBJECT_NAME_IS_NOT";
  return DataSourceFilterType;
}({});
(function (_DataSourceFilterType) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DataSourceFilterType[enumVal] != null ? enumVal : undefined : DataSourceFilterType[enumVal];
  }
  _DataSourceFilterType.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DataSourceFilterType.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DataSourceFilterType.indexOf = indexOf;
})(DataSourceFilterType || (DataSourceFilterType = {}));
//# sourceMappingURL=DataSourceFilterType.js.map
